import './App.css'
import coin from './assets/3d/kaspa-coin.gltf'
import {message} from 'antd'
import React, {useEffect, useRef, useState} from 'react'
import PieChart from './component/PieChart'

function App() {
    const [messageApi, contextHolder] = message.useMessage()
    const childRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [addressData, setAddressData] = useState(null)
    const [isVisible, setIsVisible] = useState(false)
    const inputElement = useRef(null)
    const [address, setAddress] = useState('')
    const [totalNumer, setTotalNumer] = useState(0)
    const [isfocus, setFocus] = useState(false)
    const [totalNumStatus, setTotalNumStatus] = useState('none')
    let oldNumber = 0
    const closeMessage = () => {
        messageApi.destroy()
    }
    // Change the input field address
    const inputChangeHandler = () => {
        handleInputKeyPress()
        setAddress(inputElement.current.value)
    }
    const handleInputKeyPress = (event) => {
        inputElement.current.value = inputElement.current.value.replace(/[^0-9a-zA-Z:]/g, '')
    }

    // Change Visibility
    const toggleVisibility = () => {
        inputElement.current && (inputElement.current.value = '')
        inputElement.current && setAddress(inputElement.current.value)
        !isVisible && childRef.current && childRef.current.fetchData()
        !isVisible && setAddressData(null)
        console.log(childRef.current)
        setIsVisible(!isVisible)
    }
    // Click claim event
    const claimEvent = async (e) => {
        const url = `https://api.houndcoin.org/getAirdrop?address=${address}`
        e?.preventDefault()
        inputElement && inputElement.current.blur()
        changeBlur()
        closeMessage()
        if (address.length === 0) {
            messageApi.open({
                type: 'warning',
                content: `No Address`
            })
        } else {
            if (address.length <= 6 || !address.includes('kaspa:')) {
                messageApi.open({
                    type: 'warning',
                    content: `Wrong Address`
                })
                return false
            }
            setLoading(true)
            try {
                const params = {address: address}
                setAddressData(params)
                fetch(url)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then((data) => {
                        data.address = address
                        console.log(data)
                        setLoading(false)
                        setAddressData(data)
                    })
                    .catch((error) => {
                        messageApi.open({
                            type: 'warning',
                            content: `Wrong Address`
                        })
                        setAddressData(null)
                        setLoading(false)
                    })
            } catch (e) {
                console.error(e)
            }
        }
    }

    function getTotalUtxosNum() {
        const url = 'https://api.houndcoin.org/getTotalUtxosNum'
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.warn('getTotalUtxosNum', data)
                let status = 'none'
                const totalNum = Number(data.totalNum)
                if (totalNum > oldNumber) {
                    status = 'up'
                } else if (totalNum < oldNumber) {
                    status = 'down'
                }
                setTotalNumer(totalNum)
                setTotalNumStatus(status)
                const Timeout1 = setTimeout(() => {
                    oldNumber = totalNum
                    clearTimeout(Timeout1)
                }, 1000);
                const Timeout = setTimeout(() => {
                    setTotalNumStatus('none')
                    getTotalUtxosNum()
                    clearTimeout(Timeout)
                }, 10000);
            })
            .catch((error) => {
                const Timeout = setTimeout(() => {
                    setTotalNumStatus('none')
                    getTotalUtxosNum()
                    clearTimeout(Timeout)
                }, 10000);
            })
    }
    const changeFocus = () => {
      setFocus(true)
    }
    const changeBlur = () => {
        setFocus(false)
    }
    // Click verify event
    const verifyEvent = () => {
        closeMessage()
        messageApi.open({
            type: 'warning',
            content: `Not Assigned Yet`
        })
    }
    const shareEvent = (value) => {
        closeMessage()
        messageApi.open({
            type: 'warning',
            content: `$HOUND has no ${value} `
        })
    }
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                setAddress(inputElement.current.value)
                claimEvent()
            }
        }
        try {
            getTotalUtxosNum()
        } catch (e) {
            console.error(e)
        }
        inputElement.current && inputElement.current.addEventListener('keypress', handleKeyPress)
        return () => {
            inputElement.current && inputElement.current.removeEventListener('keypress', handleKeyPress)
        }
    }, [])
    return (
        <div className="main">
            <div>
                <div className="model-shown">
                    <model-viewer
                        src={coin}
                        ios-src={coin}
                        alt="gold"
                        camera-orbit="0deg 90deg"
                        disable-pan
                        auto-rotate
                        camera-controls
                        autoplay
                        auto-rotate-delay="0"
                        rotation-per-second="25deg"
                        disable-zoom
                        touch-action="none"
                        interaction-prompt="none"
                        id="neutral-demo"
                        tone-mapping="neutral"
                    ></model-viewer>
                </div>
                <div className="tips">
                    Transfer $KAS, Farm <span onClick={toggleVisibility}>$HOUND</span>
                </div>
                <section className={isVisible ? 'active explain-box' : 'explain-box'}>
                    <div className="explain-container">
                        <h3 className="explain-title"><span>What is $HOUND?</span></h3>
                        <span>$HOUND is a KRC20 token created on KASPA, 100% of $HOUND will be distributed by UTXOs count of address. $HOUND
                            has no founder, no team, and no reservations.</span>
                        <br/>
                        <br/>
                        <h3 className="explain-title"><span>Why was $HOUND Created?</span></h3>
                        <span>$HOUND is an experimental project on KASPA, which aims to let the crypto industry understand the capabilities of
                            kaspa. This is not a financial advice.</span>
                        <br/>
                        <br/>
                        <h3 className="explain-title"><span>Distribution Mechanism</span></h3>
                    <span>A snapshot will be taken when the mainnet block time is 2024-08-20 20:00:00. Once the snapshot is complete, each address will receive $HOUND tokens.</span>
                    <br/><span>Received $HOUND Amount = [Each address UTXOs count(>1) at shapshot ÷ Total UTXOs count(>1) at shapshot] × Max supply</span>
                    <br/><span>Max Supply: 100,000,000,000</span>
                    <br/><span>Snapshot Block Time: 2024-08-20 20:00:00</span><br/>
                    <br/>
                    <h3 className="explain-title"><span>UTXOs Real-Time Data</span></h3>
                        <span>Total UTXOs Count(>1): </span>
                        <span>{totalNumer}</span>
                        { (totalNumStatus ==='up' || totalNumStatus ==='down') && (<div className="totalNumStatus">
                        <span className={totalNumStatus}>{totalNumStatus === 'up' ? '↑' : ''}{totalNumStatus === 'down' ? '↓' : ''}</span>
                    </div>)}
                    <br/>
                    <PieChart ref={childRef}/>
                    <h3 className="explain-title"><span>Social Media</span></h3>
                    <span className="red">
                                <span>$HOUND doesn't have any form of social media, the only place you can reach it is </span>
                        <a href="https://houndcoin.org" target="_blank">
                                    <span>houndcoin.org</span>
                                </a>
                            </span>
            </div>
        </section>
{
    !isVisible && (
        <section className="input-con-box">
            <div className={isfocus ? 'focusInput input-con flex flex-ac' : 'input-con flex flex-ac'}>
                <div className="icon-search flex flex-ac flex-hc">
                    <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path
                            d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                </div>
                <form onSubmit={claimEvent}>
                    <input
                        type="search"
                        ref={inputElement}
                        onChange={inputChangeHandler}
                        onBlur={changeBlur}
                        onFocus={changeFocus}
                        placeholder="View your $HOUND rewards by kaspa address"
                    />
                </form>
            </div>
            <div className="button-con flex flex-ac flex-hc">
                            <span className="button" onClick={claimEvent}>
                                Expected Rewards
                            </span>
                <span className="button" onClick={verifyEvent}>
                                Verify Distribution
                            </span>
            </div>
        </section>
    )
}
{
    !isVisible && addressData && (
        <ul className='dataList'>
            <li>{addressData && addressData.address}</li>
            <li>UTXOs Count: {!loading && addressData && (<span>{addressData.selfNum}</span>)}{loading && (
                <div className="dots-icon"><span className="dots">...</span></div>)}</li>
            <li>Expected Rewards: {loading && (
                <div className="dots-icon"><span className="dots">...</span></div>)}{!loading && addressData && (
                <span>{addressData.airdrop / 100000000}$HOUND</span>)}</li>
            <li>Percentage of Max Supply: {loading && (
                <div className="dots-icon"><span className="dots">...</span></div>)}{!loading && addressData && (
                <span>{addressData.airdrop == 0 ? 0 : (addressData.selfNum / addressData.totalNum * 10000 / 100).toFixed(8)}%</span>)}</li>
        </ul>
    )
}
{
    contextHolder
}
</div>
    <section className="share-list">
        <a onClick={() => shareEvent('Facebook')} className="facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
            </svg>
        </a>
        <a onClick={() => shareEvent('Discord')} className="discord">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
                <path
                    d="M 41.625 10.769531 C 37.644531 7.566406 31.347656 7.023438 31.078125 7.003906 C 30.660156 6.96875 30.261719 7.203125 30.089844 7.589844 C 30.074219 7.613281 29.9375 7.929688 29.785156 8.421875 C 32.417969 8.867188 35.652344 9.761719 38.578125 11.578125 C 39.046875 11.867188 39.191406 12.484375 38.902344 12.953125 C 38.710938 13.261719 38.386719 13.429688 38.050781 13.429688 C 37.871094 13.429688 37.6875 13.378906 37.523438 13.277344 C 32.492188 10.15625 26.210938 10 25 10 C 23.789063 10 17.503906 10.15625 12.476563 13.277344 C 12.007813 13.570313 11.390625 13.425781 11.101563 12.957031 C 10.808594 12.484375 10.953125 11.871094 11.421875 11.578125 C 14.347656 9.765625 17.582031 8.867188 20.214844 8.425781 C 20.0625 7.929688 19.925781 7.617188 19.914063 7.589844 C 19.738281 7.203125 19.34375 6.960938 18.921875 7.003906 C 18.652344 7.023438 12.355469 7.566406 8.320313 10.8125 C 6.214844 12.761719 2 24.152344 2 34 C 2 34.175781 2.046875 34.34375 2.132813 34.496094 C 5.039063 39.605469 12.972656 40.941406 14.78125 41 C 14.789063 41 14.800781 41 14.8125 41 C 15.132813 41 15.433594 40.847656 15.621094 40.589844 L 17.449219 38.074219 C 12.515625 36.800781 9.996094 34.636719 9.851563 34.507813 C 9.4375 34.144531 9.398438 33.511719 9.765625 33.097656 C 10.128906 32.683594 10.761719 32.644531 11.175781 33.007813 C 11.234375 33.0625 15.875 37 25 37 C 34.140625 37 38.78125 33.046875 38.828125 33.007813 C 39.242188 32.648438 39.871094 32.683594 40.238281 33.101563 C 40.601563 33.515625 40.5625 34.144531 40.148438 34.507813 C 40.003906 34.636719 37.484375 36.800781 32.550781 38.074219 L 34.378906 40.589844 C 34.566406 40.847656 34.867188 41 35.1875 41 C 35.199219 41 35.210938 41 35.21875 41 C 37.027344 40.941406 44.960938 39.605469 47.867188 34.496094 C 47.953125 34.34375 48 34.175781 48 34 C 48 24.152344 43.785156 12.761719 41.625 10.769531 Z M 18.5 30 C 16.566406 30 15 28.210938 15 26 C 15 23.789063 16.566406 22 18.5 22 C 20.433594 22 22 23.789063 22 26 C 22 28.210938 20.433594 30 18.5 30 Z M 31.5 30 C 29.566406 30 28 28.210938 28 26 C 28 23.789063 29.566406 22 31.5 22 C 33.433594 22 35 23.789063 35 26 C 35 28.210938 33.433594 30 31.5 30 Z"/>
            </svg>
        </a>
        <a onClick={() => shareEvent('Instagram')} className="instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
        </a>
        <a onClick={() => shareEvent('Medium')} className="medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="30px" height="30px">
                <path
                    d="M8.5 7A8.5 8.5 0 108.5 24 8.5 8.5 0 108.5 7zM22 8A4 7.5 0 1022 23 4 7.5 0 1022 8zM28.5 9A1.5 6.5 0 1028.5 22 1.5 6.5 0 1028.5 9z"/>
            </svg>
        </a>
        <a onClick={() => shareEvent('Reddit')} className="reddit">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M24 11.779c0-1.459-1.192-2.645-2.657-2.645-.715 0-1.363.286-1.84.746-1.81-1.191-4.259-1.949-6.971-2.046l1.483-4.669 4.016.941-.006.058c0 1.193.975 2.163 2.174 2.163 1.198 0 2.172-.97 2.172-2.163s-.975-2.164-2.172-2.164c-.92 0-1.704.574-2.021 1.379l-4.329-1.015c-.189-.046-.381.063-.44.249l-1.654 5.207c-2.838.034-5.409.798-7.3 2.025-.474-.438-1.103-.712-1.799-.712-1.465 0-2.656 1.187-2.656 2.646 0 .97.533 1.811 1.317 2.271-.052.282-.086.567-.086.857 0 3.911 4.808 7.093 10.719 7.093s10.72-3.182 10.72-7.093c0-.274-.029-.544-.075-.81.832-.447 1.405-1.312 1.405-2.318zm-17.224 1.816c0-.868.71-1.575 1.582-1.575.872 0 1.581.707 1.581 1.575s-.709 1.574-1.581 1.574-1.582-.706-1.582-1.574zm9.061 4.669c-.797.793-2.048 1.179-3.824 1.179l-.013-.003-.013.003c-1.777 0-3.028-.386-3.824-1.179-.145-.144-.145-.379 0-.523.145-.145.381-.145.526 0 .65.647 1.729.961 3.298.961l.013.003.013-.003c1.569 0 2.648-.315 3.298-.962.145-.145.381-.144.526 0 .145.145.145.379 0 .524zm-.189-3.095c-.872 0-1.581-.706-1.581-1.574 0-.868.709-1.575 1.581-1.575s1.581.707 1.581 1.575-.709 1.574-1.581 1.574z"/>
            </svg>
        </a>
        <a onClick={() => shareEvent(' Telegram')} className="telegram">
            <svg
                t="1718900047489"
                className="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="12285"
                width="200"
                height="200"
            >
                <path
                    d="M1021.10368 160l-155.2 728c-11.2 51.2-41.6 64-84.8 40L545.90368 756.8 432.30368 865.6c-12.8 12.8-22.4 22.4-48 22.4l17.6-240 436.8-393.6c19.2-17.6-4.8-25.6-28.8-9.6L269.10368 584 37.10368 512c-51.2-16-51.2-51.2 11.2-75.2L955.50368 86.4c43.2-14.4 80 9.6 65.6 73.6z"
                    p-id="12286"
                    fill="#111421"
                ></path>
            </svg>
        </a>
        <a onClick={() => shareEvent('Twitter')} className="twitter">
            <svg
                t="1718899970393"
                className="icon"
                viewBox="0 0 1142 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="11254"
                width="200"
                height="200"
            >
                <path
                    d="M890.380242 0.612284h173.362209L684.996332 433.485792l445.555998 589.043233h-348.863678l-273.246619-357.252714-312.649326 357.252714H22.325961l405.10046-463.013555L0.003733 0.612284h357.719395l246.989346 326.537717L890.380242 0.612284z m-60.843845 918.15329h96.057635L305.525926 98.924916H202.44196l627.094437 819.840658z m0 0"
                    p-id="11255"
                    fill="#111421"
                ></path>
            </svg>
        </a>
        <a onClick={() => shareEvent('Youtube')} className="youtube">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path
                    d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
            </svg>
        </a>
    </section>
</div>
)
}

export default App
